import React from "react";
import { mdiShareVariant, mdiFacebook, mdiTwitter, mdiLink } from "@mdi/js";

import { FlexGrid } from "../globals";
import Icon from "../icon";
import IconButton from "../iconButton";
import MenuButton from "../menuButton";

const Share = ({ link }) => (
  <div
    css={`
      margin-top: 4px;
    `}
  >
    <MenuButton
      children={
        <Icon
          symbol={mdiShareVariant}
          size={1.5}
          css={`
            cursor: pointer;
            height: 1.5rem;
          `}
        />
      }
      content={
        <div
          css={`
            padding: 16px;
          `}
        >
          <FlexGrid gutterX={[2]}>
            <div>
              <IconButton
                icon={mdiFacebook}
                variant="facebook"
                as="a"
                target="_blank"
                href={
                  "https://www.facebook.com/sharer/sharer.php?u=" +
                  encodeURIComponent(
                    link
                      ? link
                      : typeof window !== "undefined" && window.location.href
                  )
                }
              />
            </div>
            <div>
              <IconButton
                icon={mdiTwitter}
                variant="twitter"
                as="a"
                target="_blank"
                href={
                  "https://twitter.com/intent/tweet?text=" +
                  (link
                    ? link
                    : typeof window !== "undefined" && window.location.href)
                }
              />
            </div>
            {/* <div>
              <IconButton icon={mdiLink} variant="default" />
            </div> */}
          </FlexGrid>
        </div>
      }
    />
  </div>
);

export default Share;
